import React, { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { getTeamUrl } from '../../utils/routes';
import { shortenTeamName } from '../../utils/functionalUtils';
import { DataContext } from '../../context/data-context';

function StandingsRow({ data, logo }) {
  const { currentSeason } = useContext(DataContext);
  const { position, name, stats, previousPosition, borderType, teamAbbrv } =
    data;

  const statistics = {
    gp: stats?.find((i) => i.name === 'gp').value,
    w: stats?.find((i) => i.name === 'w').value,
    t: stats?.find((i) => i.name === 't').value,
    l: stats?.find((i) => i.name === 'l').value,
    gf: stats?.find((i) => i.name === 'gf').value,
    ga: stats?.find((i) => i.name === 'ga').value,
    pts: stats?.find((i) => i.name === 'pts').value,
  };

  const arrow = previousPosition >= position ? 'up' : 'down';
  const hideArrow = previousPosition === null || previousPosition === position;

  const arrowClass = arrow === 'up' ? 'arrow--up' : 'arrow--down';
  const arr = hideArrow ? `${arrowClass} invisible` : arrowClass;

  const getContainerStyle = () => {
    if (position === 1 && borderType === 'borderbottom') {
      return 'stats-table__row stats-table__row--cutoff bg-comp-pink';
    }
    if (position === 1 && borderType === 'noborder') {
      return 'stats-table__row bg-comp-pink';
    }

    if (position !== 1 && borderType === 'noborder') {
      return 'stats-table__row';
    }

    if (position !== 1 && borderType === 'borderbottom') {
      return 'stats-table__row stats-table__row--cutoff';
    }

    return '';
  };

  return (
    <div className={getContainerStyle()}>
      {' '}
      <div className="stats-table__position stats-table__position--status">
        <svg
          className={arr}
          width="11"
          height="13"
          viewBox="0 0 11 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
            fill="currentColor"
          />
        </svg>
        {position}
      </div>
      <a
        style={{ pointerEvents: currentSeason >= 2023 ? 'auto' : 'none' }}
        href={getTeamUrl(teamAbbrv)}
        className="stats-table__name text-decoration-none text-color-primary-white"
      >
        <div className="name-with-team-logo name-with-team-logo--mobile-hide-logo">
          <img src={logo} alt="" />
          <span className="d-none d-sm-inline-block">{name}</span>
          <span className="d-inline-block d-sm-none">
            {shortenTeamName(name)}
          </span>
        </div>
      </a>
      <div className="stats-table__games">{statistics.gp}</div>
      <div className="stats-table__wins">{statistics.w}</div>
      <div className="stats-table__ties">{statistics.t}</div>
      <div className="stats-table__losses">{statistics.l}</div>
      <div className="stats-table__plus-minus">
        {statistics.gf}-{statistics.ga}
      </div>
      <div className="stats-table__points">{statistics.pts}</div>
    </div>
  );
}

StandingsRow.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    stats: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ),
    teamAbbrv: PropTypes.string.isRequired,
    teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    teamShortName: PropTypes.string.isRequired,
    teamShorterName: PropTypes.string.isRequired,
  }).isRequired,
  logo: PropTypes.string,
};

StandingsRow.defaultProps = {
  logo: '',
};

export default StandingsRow;
